var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar[data-v-48b450dd]{padding:20px}.day[data-v-48b450dd]{font-weight:500;font-size:2em;margin-bottom:10px}.date-wrap[data-v-48b450dd]{background:url(" + escape(require("../assets/bg-number.png")) + ") no-repeat;background-size:100%;color:transparent;-webkit-background-clip:text;background-clip:text}.date[data-v-48b450dd]{line-height:1em;font-family:Acumin Pro Bold;margin-bottom:0;font-size:15em;font-weight:700}.month[data-v-48b450dd]{margin-top:-30px;margin-bottom:0;font-size:3em;font-weight:700}.lunar-date[data-v-48b450dd]{color:red;font-size:1.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48b450dd","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Calendar.vue
// module id = es0c
// module chunks = 1